import { render, staticRenderFns } from "./vFormHORIZONTAL_SPACE.vue?vue&type=template&id=088663f7&scoped=true&"
import script from "./vFormHORIZONTAL_SPACE.vue?vue&type=script&lang=js&"
export * from "./vFormHORIZONTAL_SPACE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088663f7",
  null
  
)

export default component.exports